const colors = {
  primaryMain: "#4EBAA1",
  primaryLight: "#78F8D5",
  primaryDark: "#002019",

  primary99: "#FDFEFE",
  primary95: "#F6FCFA",
  primary90: "#EDF8F6",
  primary80: "#DCF1EC",
  primary70: "#C9EAE3",
  primary60: "#B8E3D9",
  primary50: "#A6DDD0",
  primary40: "#95D6C7",
  primary30: "#83CFBD",
  primary20: "#71C8B4",
  primary10: "#61C0AA",

  primary80Black: "#3E9581",

  secondaryMain: "#4B645B",
  secondaryLight: "#CEE9DE",
  secondaryDark: "#072019",

  tertiaryMain: "#416276",

  neutral: "#5C5F5D",
  outline: "#707975",
  buttonText: "#008566",
  link: "#00876D",
  seed: "#58DBB9",

  successGreen: "#52C95D",
  error: "#BA1B1B",
  infoBlue: "#58ACDB",
  warningYellow: "#FFC107",
  digitalYellow: "#D6FC51",
  electricBlue: "#0066FF",
  indianRed: "#DB5461",
  darkIndianRed: "#D43544",
  sweetBrown: "#A7353D",

  surface: "#FBFDFA",
  surface1: "#EFF6F2",
  surface2: "#E7F1ED",
  surface3: "#DFEDE8",
  surface4: "#DDEBE6",
  surface5: "#D8E9E3",
  cloudGrey: "#EEF2F6",

  neutral99: "#FBFDFA",
  neutral95: "#EFF1EE",
  neutral90: "#E0E3E0",
  neutral80: "#C4C7C4",
  neutral70: "#A9ACA9",
  neutral60: "#8E928F",
  neutral50: "#757876",
  neutral40: "#5C5F5D",
  neutral30: "#444846",
  neutral20: "#2D312F",
  neutral10: "#191C1B",
  
  slate: "#20242A",
  slate99: "#FDFDFD",
  slate95: "#F4F4F4",
  slate90: "#E9E9EA",
  slate80: "#D2D3D4",
  slate70: "#BCBDBF",
  slate60: "#A6A7AA",
  slate50: "#8E9295",
  slate40: "#797D7F",
  slate30: "#63666A",
  slate20: "#4D5055",
  slate10: "#363A3F",

  white: "#FFFFFF",
  black: "#000000",

  red50: "#ffebee",
  red100: "#ffcdd2",
  red200: "#ef9a9a",
  red300: "#e57373",
  red400: "#ef5350",
  red500: "#f44336",
  red600: "#e53935",
  red700: "#d32f2f",
  red800: "#c62828",
  red900: "#b71c1c",
  redA100: "#ff8a80",
  redA200: "#ff5252",
  redA400: "#ff1744",
  redA700: "#d50000",
}

export default colors;
